import { InfinityTrackingCssClass } from '@helpers/global';
import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './CallButton.styles';
const CallButton = (props) => {
    return (React.createElement(S.Container, { className: InfinityTrackingCssClass, href: props.url },
        React.createElement(S.IconWrapper, null,
            React.createElement(S.Icon, { alt: "", src: imageUrl(props.icon, {}) })),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Telephone, null,
                React.createElement(S.TelephoneLabel, null, props.telephoneLabel),
                React.createElement(S.TelephoneValue, null, props.telephone)),
            (props.hours || props.hoursLabel) && (React.createElement(S.Hours, null,
                props.hoursLabel && React.createElement(S.HoursLabel, null, props.hoursLabel),
                props.hours && React.createElement(S.HoursValue, null, props.hours))))));
};
export default CallButton;
